import { useState } from 'react';

function BrandImage({ onComplete }) {
  const [formData, setFormData] = useState({
    brandStyle: {
      classic: 50,
      mature: 50,
      feminine: 50,
      playful: 50,
      economical: 50,
      geometric: 50,
      abstract: 50
    },
    logo: null,
    colors: {
      background: '#FFFFFF',
      button: '#0049ac',
      text: '#000000',
      buttonLabel: '#FFFFFF'
    }
  });

  const handleStyleChange = (style, value) => {
    setFormData(prev => ({
      ...prev,
      brandStyle: {
        ...prev.brandStyle,
        [style]: value
      }
    }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        logo: file
      }));
    }
  };

  const handleColorChange = (type, value) => {
    setFormData(prev => ({
      ...prev,
      colors: {
        ...prev.colors,
        [type]: value
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(true);
  };

  const styleOptions = [
    { name: 'classic', left: 'Classic', right: 'Avant-garde' },
    { name: 'mature', left: 'Mature', right: 'Youthful' },
    { name: 'feminine', left: 'Feminine', right: 'Masculine' },
    { name: 'playful', left: 'Playful', right: 'Sophisticated' },
    { name: 'economical', left: 'Economical', right: 'Luxurious' },
    { name: 'geometric', left: 'Geometric', right: 'Organic' },
    { name: 'abstract', left: 'Abstract', right: 'Literal' }
  ];

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-pink-500">🎨</span>
        <h2 className="text-lg font-medium">Brand Image</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        A brand's identity is defined by its distinctive style, visual elements such as colors and logo, shaping the perceptions and recognition it garners from consumers.
      </p>

      <form onSubmit={handleSubmit} className="space-y-8">
        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-4">Brand style</h3>
          <p className="text-sm text-gray-500 mb-6">
            Based on the designs you selected here are the styles you'll want Glowtify AI to explore. Don't worry, you can change the styles after the designs are created.
          </p>

          <div className="space-y-6">
            {styleOptions.map((style) => (
              <div key={style.name} className="space-y-2">
                <div className="flex justify-between text-sm text-gray-600">
                  <span>{style.left}</span>
                  <span>{style.right}</span>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={formData.brandStyle[style.name]}
                  onChange={(e) => handleStyleChange(style.name, e.target.value)}
                  className="w-full"
                />
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-4">Logo</h3>
          <p className="text-sm text-gray-500 mb-4">
            Your store's logo is a key part of your brand identity. Upload your logo to make your store stand out.
          </p>

          <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
            <div className="text-center">
              <div className="mt-4 flex text-sm leading-6 text-gray-600">
                <label
                  htmlFor="logo-upload"
                  className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                >
                  <span>Upload a file</span>
                  <input
                    id="logo-upload"
                    name="logo-upload"
                    type="file"
                    className="sr-only"
                    onChange={handleLogoUpload}
                    accept="image/*"
                  />
                </label>
                <p className="pl-1">or drag and drop</p>
              </div>
              <p className="text-xs leading-5 text-gray-600">PNG, JPG, GIF up to 10MB</p>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-4">Color palette</h3>
          <p className="text-sm text-gray-500 mb-4">
            Select and define information about your brand's primary colors!
          </p>

          <div className="grid grid-cols-4 gap-4">
            {Object.entries(formData.colors).map(([type, color]) => (
              <div key={type} className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 capitalize">
                  {type.replace(/([A-Z])/g, ' $1').trim()}
                </label>
                <input
                  type="color"
                  value={color}
                  onChange={(e) => handleColorChange(type, e.target.value)}
                  className="h-10 w-full rounded-lg border border-gray-300 cursor-pointer"
                />
                <input
                  type="text"
                  value={color}
                  onChange={(e) => handleColorChange(type, e.target.value)}
                  className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
          >
            Save & Continue
          </button>
        </div>
      </form>
    </div>
  );
}

export default BrandImage;